import { buildApiUrl } from "@/lib/api";

export function buildGoogleOAuthUrl(tenant: string): string {
  return buildApiUrl(`/auth/google/redirect?tenant=${encodeURIComponent(tenant)}`);
}
